<template>
  <div style="color:#fff" class="rightBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig" style="height:100%;width:100%;">
        <bar-card class="lefts" :bg="'border2'">
          <v-title>基地/品种种植规模排行</v-title>
          <div class="panelContent">
            <right-top />
          </div>
        </bar-card>
        <bar-card class="lefts lefts2" :bg="'border2'">
          <v-title>各区种植面积占比</v-title>
          <div class="panelContent">
            <right-mid />
          </div>
        </bar-card>
        <bar-card class="lefts lefts3" :bg="'border2'">
          <v-title>种植基地</v-title>
          <div class="panelContent">
            <right-bot />
          </div>
        </bar-card>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import rightTop from "./rightBar/rightTop";
import rightMid from "./rightBar/rightMid";
import rightBot from "./rightBar/rightBot";
export default {
  components: { rightTop, rightBot, rightMid },
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
.panelContent
  height calc(100% - 43px)
  color #fff
.lefts
  height 40%
  margin-bottom 10px
.lefts2
    height calc(30% - 10px)
    margin-bottom 10px
.lefts3
    height 30%
@media (min-height 1400px)
  .rightBar
    >>>.side
      width 24% !important
</style>
